import { render } from "./FunIcon.vue?vue&type=template&id=61404c4a&ts=true"
import script from "./FunIcon.vue?vue&type=script&lang=ts"
export * from "./FunIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__